import React from 'react'
import {FormattedMessage} from 'react-intl'

const LoadMore = _ => {
  return <div className="load-more">
    <center>
      <FormattedMessage id="Loading more estates" defaultMessage="Loading more estates"/>
    </center>
  </div>
}

export default LoadMore



/** WEBPACK FOOTER **
 ** ./app/components/LoadMore.jsx
 **/